export default "__VITE_ASSET__atYwks12__"